import { useEffect, useState } from "react";
import { sliderApi } from "../api/sliderApi";
import { newsApi } from "../api/newsApi";

export default function Dashboard() {
  // ✅ Slider KPI
  const [count, setCount] = useState(0);
  const [withImg, setWithImg] = useState(0);
  const [lastId, setLastId] = useState("-");

  // ✅ News KPI
  const [newsCount, setNewsCount] = useState(0);
  const [newsWithImg, setNewsWithImg] = useState(0);
  const [newsLastId, setNewsLastId] = useState("-");

  const [err, setErr] = useState("");

  useEffect(() => {
    const load = async () => {
      setErr("");
      try {
        const [slRes, nwRes] = await Promise.all([
          sliderApi.getAll(),
          newsApi.getAll(),
        ]);

        // sliders
        const sliders = slRes.data || [];
        setCount(sliders.length);
        setWithImg(sliders.filter((x) => x.hasImage).length);
        setLastId(sliders[0]?.id ?? "-");

        // news
        const news = nwRes.data || [];
        setNewsCount(news.length);
        setNewsWithImg(news.filter((x) => x.hasImage).length);
        setNewsLastId(news[0]?.id ?? "-");
      } catch (e) {
        setErr(e?.response?.data || e.message || "Dashboard load failed");
      }
    };
    load();
  }, []);

  return (
    <div>
      <h1 className="pageTitle">Dashboard</h1>

      {err ? (
        <div className="card">
          <div className="cardBody" style={{ color: "rgba(255,77,79,.9)" }}>
            {String(err)}
          </div>
        </div>
      ) : null}

      {/* ✅ 6 KPI -> grid3 iki sətir kimi görünəcək */}
      <div className="grid3">
        {/* Sliders */}
        <div className="card">
          <div className="cardBody kpi">
            <div className="kpiLabel">Total Sliders</div>
            <div className="kpiValue">{count}</div>
          </div>
        </div>

        {/* News */}
        <div className="card">
          <div className="cardBody kpi">
            <div className="kpiLabel">Total News</div>
            <div className="kpiValue">{newsCount}</div>
          </div>
        </div>

      </div>
    </div>
  );
}
